var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "range-picker" },
    [
      _c("v-text-field", {
        attrs: {
          label: "Currently viewing data for",
          "append-icon": "mdi-calendar",
          readonly: ""
        },
        on: {
          "click:append": function($event) {
            _vm.dialog = true
          }
        },
        model: {
          value: _vm.dateRangeText,
          callback: function($$v) {
            _vm.dateRangeText = $$v
          },
          expression: "dateRangeText"
        }
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              _vm.dialog = false
            }
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("v-date-picker", {
            attrs: { range: "", "first-day-of-week": 4, "picker-date": "" },
            model: {
              value: _vm.selectedRange,
              callback: function($$v) {
                _vm.selectedRange = $$v
              },
              expression: "selectedRange"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }